import { render } from "./StudioProductManager.vue?vue&type=template&id=681ef92b"
import script from "./StudioProductManager.vue?vue&type=script&lang=js"
export * from "./StudioProductManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__